module.exports = __webpack_public_path__ + "img/ms.6175b67f.svg";